import React from 'react'
import PropTypes from 'prop-types'

import { withSnowplowContexts } from '@cred/react-analytics/SnowplowContextManager'

import { DEFAULT_ADVERTISER_DISCLOSURE, WSJ_THEME } from 'common/constants'
import FooterLinks from 'components/footer-links'

import MortgageCombinedFooter from './components/MortgageCombinedFooter'
import StudentLoanCombinedFooter from './components/StudentLoanCombinedFooter'
import styles from './styles.modue.scss'

const RichCtaFooter = ({
  theme,
  footerDisclosure = DEFAULT_ADVERTISER_DISCLOSURE,
  trackSnowplowEvent,
  verticals,
  show,
}) => {
  if (!show) return null

  const isWsjTheme = theme === WSJ_THEME

  const linkClassName = isWsjTheme ? 'neutral500' : ''
  const wrapperClassName = isWsjTheme ? styles.wsgContainer : ''
  const footerProps = {
    footerDisclosure,
    trackSnowplowEvent,
    showDisclosure: true,
    wrapperClassName,
    linkClassName,
  }

  if (verticals === 'mortgage-combined') {
    return <MortgageCombinedFooter {...footerProps} />
  }
  if (verticals === 'student-loan-combined') {
    return <StudentLoanCombinedFooter {...footerProps} />
  }
  if (verticals === 'personal-loan') {
    return (
      <FooterLinks
        dividerClassName="ml-8 mr-8"
        linkClassName={linkClassName}
        containerClassName={wrapperClassName}
      />
    )
  }
  if (isWsjTheme) {
    return (
      <FooterLinks
        dividerClassName="ml-8 mr-8"
        linkClassName={linkClassName}
        containerClassName={wrapperClassName}
        showPrivacy
      />
    )
  }
  return null
}

RichCtaFooter.propTypes = {
  theme: PropTypes.string,
  footerDisclosure: PropTypes.string,
  trackSnowplowEvent: PropTypes.func.isRequired,
  verticals: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
  show: PropTypes.bool,
}

export { RichCtaFooter }

export default withSnowplowContexts(RichCtaFooter)
